<template>
  <form>
    <div v-if="IsShowBanner">
      <div
        class="
          d-flex
          justify-content-around
          bg-warning
          rounded
          mt-0
          mb-4
          font-weight-bold
          py-2
          p-2
          h5
        "
      >
        To determine availability for Residential placements for July and
        August, please search with School Year
        {{ this.DefaultSchoolYear - 2 }}-{{ this.DefaultSchoolYear - 1 }}.
      </div>
    </div>

    <div class="row justify-content-end mb-2">
      <div class="col-auto">
        <!-- <a
          type="button"
          role="button"
          class="btn btn-primary float-right mr-2 text-light"
          href="https://www.isbe.net"
          target="_blank"
        >
          <i class="fas fa-thumbtack mr-1" aria-hidden="true"></i>

          What's new?
        </a> -->

        <button
          type="button"
          class="btn btn-primary float-right mr-2"
          :disabled="DisableOptions"
          @click="ToggleHelp"
        >
          <i class="fas fa-question-circle mr-1" aria-hidden="true"></i> Help
        </button>
      </div>
    </div>

    <div class="pf-ghost-div p-2 m-2 small" v-if="ShowHelpText">
      The Private Facility Search application is designed to assist districts
      and parents to find special education private facilities appropriate for
      student placement. Users may specify student age and disability, distance
      from home, or various facility characteristics. Multiple filters may be
      included.
      <br />
      Results for matching facilities will include location, basic program
      information, rates, calendars and contact information.

      <p class="mt-2">
        <a
          href="https://register.gotowebinar.com/recording/1504003679821401089"
          class="btn-link"
          target="_blank"
        >
          <i class="fas fa-video"></i> Please click here to view the training webinar.
        </a> Before the video begins, you will be asked to register.
      </p>
    </div>

    <div class="row p-2">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="inputSchoolYear" class="col-md-2 col-form-label"
            >School Year</label
          >
          <div class="col-md-5">
            <select
              id="inputSchoolYear"
              class="form-control"
              v-model="SelectedSchoolYearOption"
            >
              <option value="0" selected>select...</option>
              <option
                :value="option.SchoolYear"
                v-for="(option, index) in OrderedSchoolYears"
                :key="index"
              >
                {{ option.SchoolYear - 1 }} - {{ option.SchoolYear }}
              </option>
            </select>
          </div>

          <div class="col-auto">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="FacilitiesOption"
                id="AvailableFacilities"
                value="AvailableFacilities"
                v-model="FacilityOptionSelected"
              />
              <label class="form-check-label" for="AvailableFacilities"
                >Facilities available for placement</label
              >
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="FacilitiesOption"
                id="AllFacilities"
                value="AllFacilities"
                v-model="FacilityOptionSelected"
              />
              <label class="form-check-label" for="AllFacilities"
                >All facilities</label
              >
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="FacilitiesOption"
                id="RecentlyApprovedFacilities"
                value="RecentlyApprovedFacilities"
                v-model="FacilityOptionSelected"
              />
              <label class="form-check-label" for="RecentlyApprovedFacilities"
                >Recently approved facilities</label
              >
            </div>
          </div>
        </div>

        <div class="form-group row">
          <!-- <label for="inputSchoolYear" class="col-md-2 col-form-label"></label> -->
          <div class="col-auto">
            <small class="form-text text-muted" v-if="ShowHelpText">
              By default, the search will return only facilities that are
              available for student placement. The availability choice will be
              applied in addition to any other optional filters that are
              selected.
              <ul class="ml-3">
                <li>
                  Facilities available for placement – returns only facilities
                  that are available for student placement
                </li>
                <li>
                  All Facilities – returns all open facilities, including those
                  that are not currently available for student placement
                </li>
                <li>
                  Recently approved facilities – returns only facilities that
                  have been approved in the past year
                </li>
              </ul>
            </small>
          </div>
        </div>

        <div class>
          <fieldset class="border p-2 mt-2 mb-2 CurvedBorder">
            <legend class="w-auto">Eligibility</legend>

            <div class>
              <div class="form-group row">
                <label
                  for="inputDisability1"
                  class="col-lg-2 col-md-4 col-form-label"
                  >Disability(1)</label
                >
                <div class="col-md-12 col-lg-6">
                  <select
                    id="inputDisability1"
                    class="form-control"
                    v-model="selectedDisability1Option"
                  >
                    <option value="0" selected>select...</option>
                    <option
                      :v-text="option.Description"
                      v-for="(option, index) in Disability1Options"
                      v-bind:value="{
                        id: option.DisabilityTypeId,
                        text: option.Description,
                      }"
                      :key="index"
                    >
                      {{ option.Description }}
                    </option>
                  </select>
                  <!-- <small class="form-text text-muted" v-if="ShowHelpText"
                    >This is some help text for some form entry This is some
                    help text for some form entry This is some help text for
                    School Year</small
                  > -->
                </div>
              </div>
            </div>

            <div class>
              <div class="form-group row">
                <label
                  for="inputDisability2"
                  class="col-lg-2 col-md-4 col-form-label"
                  >Disability(2)</label
                >
                <div class="col-md-12 col-lg-6">
                  <select
                    id="inputDisability2"
                    class="form-control"
                    v-model="selectedDisability2Option"
                    :disabled="selectedDisability1Option === '0'"
                  >
                    <option value="0" selected>select...</option>
                    <option
                      v-for="(option, index) in Disability2Options"
                      v-bind:value="{
                        id: option.DisabilityTypeId,
                        text: option.Description,
                      }"
                      :key="index"
                    >
                      {{ option.Description }}
                    </option>
                  </select>
                  <!-- <small class="form-text text-muted" v-if="ShowHelpText"
                    >This is some help text for some form entry This is some
                    help text for some form entry This is some help text for
                    School Year</small
                  > -->
                </div>
              </div>
            </div>

            <div class>
              <div class="form-group row">
                <label for="inputAge" class="col-md-2 col-form-label"
                  >Age</label
                >
                <div class="col-lg-3 col-md-4">
                  <input
                    type="number"
                    class="form-control"
                    id="inputAge"
                    v-model="Age"
                    min="3"
                    max="21"
                    maxlength="2"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    onblur="javascript:  if (this.value <3) this.value = 3;"
                    :disabled="selectedDisability1Option === '0'"
                  />
                  <!-- <small class="form-text text-muted" v-if="ShowHelpText"
                    >This is some help text for some form entry This is some
                    help text for some form entry This is some help text for
                    School Year</small
                  > -->
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="form-group row">
          <label for="inputName" class="col-md-2 col-form-label">Name</label>
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              id="inputName"
              maxlength="100"
              v-model="ProgramName"
            />
            <!-- <small class="form-text text-muted" v-if="ShowHelpText"
              >This is some help text for some form entry This is some help text
              for School Year This is some help text for some form entry</small
            > -->
          </div>

          <div class="form-check ml-3 mt-2">
            <input
              class="form-check-input form-control"
              type="checkbox"
              id="gridCheck2"
              v-model="NameStartsWithOption"
            />
            <label class="form-check-label" for="gridCheck2">starts with</label>
          </div>
        </div>

        <div class="form-group row mb-0">
          <label for="programCode" class="col-lg-2 col-md-2 col-form-label"
            >Program Code</label
          >
          <div class="col-md-4 col-lg-3">
            <input
              type="text"
              class="form-control"
              id="programCode"
              v-model="ProgramCode"
              maxlength="10"
            />
          </div>
          <!-- <label for="inputRCDT" class="col-md-auto col-form-label">RCDT</label>
          <input type="text" class="form-control col-md-4" id="inputRCDT" />-->
        </div>

        <div class="form-group row justify-content-center">
          <small class="col-10 form-text text-muted" v-if="ShowHelpText"
            >The program code may be used to find one specific program. The
            program code is assigned by ISBE and is documented on the approved
            34-37 for each student.</small
          >
        </div>

        <div class="form-group row">
        <!-- <label class="col-md-0 col-lg-2 col-form-label"></label> -->
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="gridCheck1"
              v-model="IsSearchWithinRadius"
            />
            <label class="form-check-label" for="gridCheck1">within</label>
          </div>
<!--
<input
  type="number"
  class="form-control col-lg-2 col-md-3 ml-1"
  id="miles"
  min="0"
  max="500"
  maxlength="3"
  v-model="Miles"
  :disabled="!IsSearchWithinRadius"
/>
&nbsp;
<label class="col-form-label"> miles of IL zipcode</label>
<input
  type="text"
  class="form-control col-lg-2 col-md-3 ml-1"
  id="zipcode"
  v-model="Zip"
  :disabled="!IsSearchWithinRadius"
/>
-->


      <label for="miles" class="sr-only">
          Number of miles
        </label>
        <input
          type="number"
          class="form-control col-lg-2 col-md-3 ml-1"
          id="miles"
          min="0"
          max="500"
          v-model="Miles"
          :disabled="!IsSearchWithinRadius"
        />

        <span class="col-form-label ml-1">
          miles of
        </span>

        <label for="zipcode" class="sr-only">
          Illinois ZIP code
        </label>
        <input
          type="text"
          class="form-control col-lg-2 col-md-3 ml-1"
          id="zipcode"
          v-model="Zip"
          :disabled="!IsSearchWithinRadius"
        />


        </div>
      </div>

      <div class="col-md-6">
        <div class>
          <fieldset class="border p-2 mt-2 mb-2 CurvedBorder">
            <legend class="w-auto">Facility Type</legend>
            <div class="form-group row pl-2 mb-2">
              <div class="col-lg-2 col-md-12">Location Type</div>
              <div class="col-lg-4 col-md-12">
                <!-- <div class="form-check">
                  <input
                    class="form-check-input"
                    name="LocationTypeCheck"
                    type="radio"
                    v-bind:value="0"
                    v-bind:id="'LT0'"
                    v-model="LocationType"
                  />
                  <label class="form-check-label" v-bind:for="'LT0'">All</label>
                </div> -->
                <div
                  class="form-check"
                  v-for="(item, index) in LocationTypeOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    name="LocationTypeCheck"
                    type="radio"
                    v-bind:value="item.LocationTypeId"
                    v-bind:id="'LT' + item.Description"
                    v-model="LocationType"
                  />
                  <label
                    class="form-check-label"
                    v-bind:for="'LT' + item.Description"
                    >{{ item.Description }}</label
                  >
                </div>
                <!-- <small class="form-text text-muted" v-if="ShowHelpText"
                  >This is some help text for some form entry This is some help
                  text for School Year This is some help text for some form
                  entry</small
                > -->
              </div>

              <div class="col-lg-2 col-md-12 mt-md-2">Facility Type</div>
              <div class="col-lg-4 col-md-12">
                <div
                  class="form-check"
                  v-for="(item, index) in FacilityTypeOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    name="FacilityTypeCheck"
                    type="checkbox"
                    v-bind:value="item.FacilityTypeId"
                    v-bind:id="'FT' + item.Description"
                    v-model="FacilityType"
                  />
                  <label
                    class="form-check-label"
                    v-bind:for="'FT' + item.Description"
                    >{{ item.Description }}</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row pl-2 mb-2">
              <div class="col-lg-6 col-md-0"></div>
              <div class="col-lg-6 col-md-12">
                <small class="form-text text-muted" v-if="ShowHelpText">
                  The Facility Type is an optional filter used to limit the
                  result set by program focus. Multiple types may be selected,
                  for example: Day School Only and Combination Only. Use the
                  Clear button to reset the selections.

                  <ul class="ml-2">
                    <li>
                      Day School Only – Selecting this option will limit results
                      to facilities which <b>only</b> offer day school programs.
                      This option will not include Combination programs
                    </li>
                    <li>
                      Residential Only – Selecting this option will limit
                      results to facilities which <b>only</b> offer residential
                      programs. This option will not include Combination
                      programs
                    </li>
                    <li>
                      Combination Only – Selecting this option will limit
                      results to facilities which provide <b>both</b> day school
                      and residential services. This option will not include Day
                      School Only programs or Residential Only programs.
                    </li>
                  </ul>
                  <!-- <p>
                    Combination programs are not returned when searching for Day
                    School programs or for Residential Facilities.
                  </p>
                  <p>
                    Day School Only programs and Residential Only programs are
                    not returned when search for Combination programs.
                  </p> -->
                </small>
              </div>
            </div>

            <div class="form-group row pl-2 mb-2">
              <div class="col-lg-2 col-md-12">Gender</div>
              <div class="col-lg-4 col-md-12">
                <div
                  class="form-check"
                  v-for="(item, index) in GenderOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    name="GenderTypeCheck"
                    type="checkbox"
                    v-bind:value="item.GenderTypeId"
                    v-bind:id="'GT' + item.Description"
                    v-model="GenderType"
                  />
                  <label
                    class="form-check-label"
                    v-bind:for="'GT' + item.Description"
                    >{{ item.Description }}</label
                  >
                </div>
                <!-- <small class="form-text text-muted" v-if="ShowHelpText"
                  >This is some help text for some form entry This is some help
                  text for School Year This is some help text for some form
                  entry</small
                > -->
              </div>

              <!-- <div class="col-lg-2 col-md-12">Add On Type</div> -->
              <div class="col-lg-4 col-md-12">
              <!--   <div
                  class="form-check"
                  v-for="(item, index) in AddOnOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    name="GenderTypeCheck"
                    type="radio"
                    v-bind:value="item.AddOnTypeId"
                    v-bind:id="'GT' + item.AddOnTypeDescription"
                    v-model="AddOnOption"
                  />
                  <label
                    class="form-check-label"
                    v-bind:for="'GT' + item.AddOnTypeDescription"
                    >{{ item.AddOnTypeDescription }}</label
                  >
                </div>  -->

                <!-- <select
                  id="inputAddOnOption"
                  class="form-control col-md-5"
                  v-model="AddOnOption"
                >
                  <option value="0" selected>select...</option>
                  <option
                    v-for="(option, index) in AddOnOptions"
                    v-bind:value="{
                      id: option.AddOnTypeId,
                      text: option.AddOnTypeDescription,
                    }"
                    :key="index"
                  >
                    {{ option.AddOnTypeDescription }}
                  </option>
                </select> -->
              </div>
            </div>

            <div class="form-group row pl-2 mb-2">
              <div class="col-lg-6 col-md-0"></div>
              <div class="col-lg-6 col-md-12">
                <small class="form-text text-muted" v-if="ShowHelpText">
                  The Add-on Type is an optional filter which will limit results
                  to specialty Day School programs:

                  <ul class="ml-2">
                    <li>
                      <u>Intensive programs</u>—for students whose IEPs indicate
                      that 1:1 support is required. NOTE: Some programs which
                      offer additional support may not be labeled as Intensive.
                      Please request assistance with identifying appropriate
                      options.
                    </li>
                    <li>
                      <u>Transition programs</u>—for students who have not
                      graduated and who need a focus on employment and living
                      skills.
                    </li>
                  </ul>
                </small>
              </div>
            </div>

            <!-- <div class="form-group row pl-2 mt-2">
              <label
                for="inputAddOnOption"
                class="col-lg-2 col-md-6 col-form-label"
                >Add On Type</label
              >
              <div class="col-lg-6 col-md-12">
                <select
                  id="inputAddOnOption"
                  class="form-control col-md-5"
                  v-model="AddOnOption"
                >
                  <option value="0" selected>select...</option>
                  <option
                    v-for="(option, index) in AddOnOptions"
                    v-bind:value="{
                      id: option.AddOnTypeId,
                      text: option.AddOnTypeDescription,
                    }"
                    :key="index"
                  >
                    {{ option.AddOnTypeDescription }}
                  </option>
                </select>
                <small class="form-text text-muted" v-if="ShowHelpText">
                  The Add-on Type is an optional filter which will limit results
                  to specialty programs:

                  <ul class="ml-2">
                    <li>
                      <u>Intensive programs</u>—for students whose IEPs indicate
                      that 1:1 support is required
                    </li>
                    <li>
                      <u>Transition programs</u>—for students who have not
                      graduated and who need a focus on employment and living
                      skills.
                    </li>
                  </ul>
                </small>
              </div>
            </div> -->
          </fieldset>
        </div>

        <div class="form-group row">
          <label
            for="inputCounty"
            class="col-lg-2 col-md-4 col-form-label mt-md-2 d-none"
            >IL County</label
          >

          <select
            id="inputCounty"
            class="form-control col-lg-3 col-md-8 mt-md-2 d-none"
            v-model="selectedCountyOption" 
          >
            <option value="0" selected>select...</option>
            <option
              v-for="(option, index) in CountyOptions"
              v-bind:value="{
                id: option.CountyTypeId,
                text: option.Description,
              }"
              :key="index"
            >
              {{ option.Description }}
            </option>
          </select>

          <label
            for="inputState"
            class="col-lg-2 col-md-4 col-form-label mt-md-2"
            >State</label
          >

          <select
            id="inputState"
            class="form-control col-lg-3 col-md-8 mt-md-2"
            v-model="selectedStateOption"
          >
            <option value="0" selected>select...</option>
            <option
              v-for="(option, index) in StateOptions"
              v-bind:value="{
                id: option.StateTypeId,
                text: option.Description,
              }"
              :key="index"
            >
              {{ option.Description }}
            </option>
          </select>
        </div>

        <div class>
          <div class="form-group row">
            <label for="inputAddress" class="col-lg-2 col-md-4 col-form-label"
              >Address</label
            >
            <input
              type="text"
              class="form-control col-lg-6 col-md-8"
              id="inputAddress"
              v-model="Address"
              maxlength="200"
            />
          </div>
        </div>

        <div class>
          <div class="form-group row">
            <label for="inputCity" class="col-lg-2 col-md-4 col-form-label"
              >City</label
            >
            <input
              type="text"
              class="form-control col-lg-3 col-md-8"
              id="inputCity"
              v-model="City"
              maxlength="50"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-around mt-2">
      <div class="col-md-6">
        <p class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="DoSearch"
            :disabled="DisableOptions"
          >
            <i class="fas fa-search mr-1" aria-hidden="true"></i>
            Search
          </button>
          <button
            type="button"
            class="btn btn-primary ml-5"
            @click="resetSearch"
            :disabled="DisableOptions"
          >
            <i class="fas fa-eraser mr-1" aria-hidden="true"></i>
            Clear
          </button>
        </p>
      </div>
    </div>

    <!-- <div class="float-right col-3 mb-2">
      <select
        class="browser-default custom-select"
        multiple
        v-model="multiSelected"
      >
        <option value="1" selected>One</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
        <option value="4">Four</option>
      </select>
    </div> -->

    <div v-if="ShowResults">
      <!-- <div class="pf-ghost-div p-2">
        <h6 class="mb-1">Hide/Show Columns</h6>

        <button
          type="button"
          class="btn btn-info btn-sm ml-2"
          v-if="showName"
          @click="DoShowName"
        >
          Name <i class="fas fa-times"></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-sm ml-2"
          v-if="!showName"
          @click="DoShowName"
        >
          Name <i class="fas fa-plus"></i>
        </button>

        <button type="button" class="btn btn-info btn-sm ml-2">
          Facility Type <i class="fas fa-times"></i>
        </button>

        <button type="button" class="btn btn-info btn-sm ml-2">
          Address <i class="fas fa-times"></i>
        </button>

        <button type="button" class="btn btn-info btn-sm ml-2">
          Location Type <i class="fas fa-plus"></i>
        </button>

        <button type="button" class="btn btn-info btn-sm ml-2">
          Add On Type <i class="fas fa-plus"></i>
        </button>

        <button type="button" class="btn btn-info btn-sm ml-2">
          Gender <i class="fas fa-plus"></i>
        </button>
      </div> -->

      <div class="row justify-content-between">
        <div class="col-10 p-2">
          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearSchoolYearSearch()"
          >
            <small class="text-muted"> School Year: </small>{{ SchoolYearSearch
            }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearMilesSearch()"
            v-if="IsSearchWithMiles"
          >
            {{ Miles }} <small class="text-muted"> miles from </small>
            {{ Zip }} <i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearCountySearch()"
            v-if="CountySearch != ''"
          >
            <small class="text-muted"> County: </small>{{ CountySearch
            }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearStateSearch()"
            v-if="StateSearch != ''"
          >
            <small class="text-muted"> State: </small>{{ StateSearch
            }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearDisability1Search()"
            v-if="Disability1Search != ''"
          >
            <small class="text-muted"> Disability(1): </small
            >{{ Disability1Search }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearDisability2Search()"
            v-if="Disability2Search != ''"
          >
            <small class="text-muted"> Disability(2): </small
            >{{ Disability2Search }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearAddOnSearch()"
            v-if="AddOnSearch != ''"
          >
            <small class="text-muted"> Add On Type: </small>{{ AddOnSearch
            }}<i class="fas fa-times-circle ml-1"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearProgramCodeSearch()"
            v-if="ProgramCodeSearch != ''"
          >
            <small class="text-muted"> Program Code: </small
            >{{ ProgramCodeSearch }} <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearProgramNameSearch()"
            v-if="ProgramNameSearch != ''"
          >
            <small class="text-muted"> Program: </small>
            {{ ProgramNameSearch }} <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearAddressSearch()"
            v-if="AddressSearch != ''"
          >
            <small class="text-muted"> Address: </small>{{ AddressSearch }}
            <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearCitySearch()"
            v-if="CitySearch != ''"
          >
            <small class="text-muted"> City: </small> {{ CitySearch }}
            <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearGenderSearch()"
            v-if="GenderTypeSearch != ''"
          >
            <small class="text-muted"> Gender: </small> {{ GenderTypeSearch }}
            <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearFacilitySearch()"
            v-if="FacilityTypeSearch != ''"
          >
            <small class="text-muted"> Facility Type: </small>
            {{ FacilityTypeSearch }}
            <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearLocationSearch()"
            v-if="LocationTypeSearch != ''"
          >
            <small class="text-muted"> Location Type: </small>
            {{ LocationTypeSearch }}
            <i class="fas fa-times-circle"></i>
          </button>

          <button
            type="button"
            class="btn btn-light m-1"
            @click="ClearFacilityScopeSearch()"
            v-if="FacilityScopeSearch != ''"
          >
            <small class="text-muted"> Facilities: </small>
            {{ FacilityScopeSearch }}
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <!-- <div class="col-auto p-2">
          <div
            class="btn-group btn-group-sm"
            role="group"
            aria-label="View Options"
          >
            <button
              type="button"
              :class="ListView ? 'btn btn-primary' : 'btn btn-link'"
              @click="OpenListView()"
            >
              <i class="fas fa-list-ul"></i>
              List
            </button>
            <button
              type="button"
              :class="MapView ? 'btn btn-primary' : 'btn btn-link'"
              @click="OpenMapView()"
            >
              <i class="fas fa-map-marker-alt"></i>
              Map
            </button>
          </div>
        </div> -->
      </div>

      <SearchResultsMapView v-if="MapView" />

      <div class="row justify-content-between mb-1" v-if="ListView">
        <div class="col-md-3 col-sm-12 text-leg">
          <div class="font-italic text-muted m-1">
            {{ ResultsCount }} results found
          </div>
        </div>

        <div class="col-md-3 col-sm-12 text-right">
          <!-- <button
            type="button"
            class="btn btn-primary m-1"
            :disabled="DisableOptions"
          >
            <i class="fas fa-print mr-1" aria-hidden="true"></i>
            Print Report
          </button> -->

          <button
            type="button"
            class="btn btn-primary ml-3"
            :disabled="DisableOptions"
            @click="GetExcel()"
          >
            <i class="fas fa-th-list mr-1" aria-hidden="true"></i>
            Export to Excel
          </button>
          <!-- </p> -->
        </div>
      </div>

      <div class="table-responsive" v-if="ListView">
        <table class="table borderless">
          <thead>
            <tr>
              <th scope="col" aria-label="Actions"></th>
              <th scope="col">Id</th>
              <th
                scope="col"
                class="pointer"
                v-if="showName"
                @click="ToggleSort()"
              >
                Name
                <i
                  class="fas fa-sort-alpha-down text-muted ml-2 fa-sm"
                  v-if="IsASCSort"
                ></i>
                <i
                  class="fas fa-sort-alpha-down-alt text-muted ml-2 fa-sm"
                  v-if="!IsASCSort"
                ></i>
              </th>
              <th scope="col">Facility Type</th>
              <th scope="col">Address</th>
            </tr>
          </thead>
          <tbody>
            <SearchResultItem
              v-for="SearchResult in SearchResults"
              :key="SearchResult.id"
              :SearchResult="SearchResult"
              :ShowName="showName"
            />
          </tbody>
        </table>
      </div>
    </div>

    <div class="p-2" v-if="!ShowResults && SearchedButNoResults">
      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearSchoolYearSearch()"
      >
        <small class="text-muted"> School Year: </small>{{ SchoolYearSearch
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearMilesSearch()"
        v-if="IsSearchWithMiles"
      >
        {{ Miles }} <small class="text-muted"> miles from </small> {{ Zip }}
        <i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearCountySearch()"
        v-if="CountySearch != ''"
      >
        <small class="text-muted"> County: </small>{{ CountySearch
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearStateSearch()"
        v-if="StateSearch != ''"
      >
        <small class="text-muted"> State: </small>{{ StateSearch
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearDisability1Search()"
        v-if="Disability1Search != ''"
      >
        <small class="text-muted"> Disability(1): </small>{{ Disability1Search
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearDisability2Search()"
        v-if="Disability2Search != ''"
      >
        <small class="text-muted"> Disability(2): </small>{{ Disability2Search
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearAddOnSearch()"
        v-if="AddOnSearch != ''"
      >
        <small class="text-muted"> Add On Type: </small>{{ AddOnSearch
        }}<i class="fas fa-times-circle ml-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearProgramCodeSearch()"
        v-if="ProgramCodeSearch != ''"
      >
        <small class="text-muted"> Program Code: </small
        >{{ ProgramCodeSearch }} <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearProgramNameSearch()"
        v-if="ProgramNameSearch != ''"
      >
        <small class="text-muted"> Program: </small>
        {{ ProgramNameSearch }} <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearAddressSearch()"
        v-if="AddressSearch != ''"
      >
        <small class="text-muted"> Address: </small>{{ AddressSearch }}
        <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearCitySearch()"
        v-if="CitySearch != ''"
      >
        <small class="text-muted"> City: </small> {{ CitySearch }}
        <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearGenderSearch()"
        v-if="GenderTypeSearch != ''"
      >
        <small class="text-muted"> Gender: </small> {{ GenderTypeSearch }}
        <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearFacilitySearch()"
        v-if="FacilityTypeSearch != ''"
      >
        <small class="text-muted"> Facility Type: </small>
        {{ FacilityTypeSearch }}
        <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearFacilityScopeSearch()"
        v-if="FacilityScopeSearch != ''"
      >
        <small class="text-muted"> Facilities: </small>
        {{ FacilityScopeSearch }}
        <i class="fas fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="btn btn-light m-1"
        @click="ClearLocationSearch()"
        v-if="LocationTypeSearch != ''"
      >
        <small class="text-muted"> Location Type: </small>
        {{ LocationTypeSearch }}
        <i class="fas fa-times-circle"></i>
      </button>
    </div>

    <div class="pf-ghost-div p-2" v-if="!ShowResults && SearchedButNoResults">
      <h6 class="mb-3">There are no matches for your search.</h6>
      Tip: Remove one or more search terms to expand your search results.
    </div>
  </form>
</template>

<script>
import SearchResultItem from "./SearchResultItem";
import SearchResultsMapView from "./SearchResultsMapView";
// import { handleFetch } from "../utilities/HttpUtilities.js";
import Constants from "../utilities/Constants.js";

export default {
  name: "SearchForm",
  components: { SearchResultItem, SearchResultsMapView },
  data() {
    return {
      selectedCountyOption: "0",
      CountyOptions: [],
      selectedStateOption: "0",
      StateOptions: [],
      AddOnOption: [],
      AddOnOptions: [],
      selectedDisability1Option: "0",
      Disability1Options: [],
      selectedDisability2Option: "0",
      Disability2Options: [],
      selectedCategotyOption: "0",
      LocationTypeOptions: [],
      LocationType: [],
      FacilityTypeOptions: [],
      FacilityType: [],
      GenderOptions: [],
      GenderType: [],
      SchoolYearOptions: [],
      SelectedSchoolYearOption: "0",
      DefaultSchoolYear: 2021,
      SearchResults: [],
      ProgramName: "",
      ProgramCode: "",
      Age: "",
      Address: "",
      City: "",
      Miles: "",
      Zip: "",
      FacilityOptionSelected: "AvailableFacilities",
      ShowResults: false,
      SearchedButNoResults: false,
      IsSearchWithinRadius: false,
      IsSearchWithMiles: false,
      showName: true,
      multiSelected: ["1"],
      DisableOptions: false,
      ShowHelpText: false,
      SchoolYearSearch: "",
      ProgramCodeSearch: "",
      ProgramNameSearch: "",
      AddressSearch: "",
      CitySearch: "",
      CountySearch: "",
      StateSearch: "",
      Disability1Search: "",
      Disability2Search: "",
      AddOnSearch: "",
      LocationTypeSearch: "",
      FacilityTypeSearch: "",
      GenderTypeSearch: [],
      FacilityScopeSearch: "",
      NameStartsWithSearch: "",
      ListView: true,
      MapView: false,
      ResultsCount: 0,
      NameStartsWithOption: false,
      IsASCSort: true,
    };
  },

  // Observe for changes
  watch: {
    selectedDisability1Option() {
      if (this.selectedDisability1Option === "0") {
        (this.selectedDisability2Option = "0"), (this.Age = "");
      }
    },
    IsSearchWithinRadius() {
      if (!this.IsSearchWithinRadius) {
        (this.Miles = ""), (this.Zip = "");
      }
    },
    Age() {
      // if(isNaN(this.Age))
      // {
      //   this.Age = 1;
      // }
      //console.log(this.Age);
      if (this.Age > 21) {
        this.Age = 21;
      }
      // if (this.Age < 3 && this.Age != "") {
      //   console.log('fsdfasdfsdf');
      //   this.Age = 3;
      // }
    },
  },

  methods: {
    loadDropdowns() {
      //console.log(Constants.API_URL);

      this.DisableOptions = true;

      document.getElementById("pageProgress").classList.remove("hidden");

      const LookUpsURL = `${Constants.API_URL}/api/PFSearchAPI/InitializePFSearch`;

      //console.log(`Getting Intialisation data from : ${LookUpsURL}`);

      const cache = localStorage.getItem(LookUpsURL);
      let o;
      if (cache) {
        o = JSON.parse(cache);
      }

      if (o && Date.now() <= o.expires) {
        this.setupLookUps(o.data);
        //console.log("got data from cache");
      } else {
        //console.log("getting data from web");

        fetch(LookUpsURL)
          .then((response) => response.json())
          .then((data) => {
            this.setupLookUps(data);

            localStorage.setItem(
              LookUpsURL,
              JSON.stringify({
                expires: Date.now() + 60 * 60 * 24 * 1000, // Cache for 24 hours
                data: data,
              })
            );
          });
      }
    },

    setupLookUps(data) {
      //console.log(data);
      this.StateOptions = data.StateTypes;
      this.Disability1Options = data.DisabilityTypes;
      this.Disability2Options = data.DisabilityTypes;
      this.CountyOptions = data.CountyTypes;
      this.AddOnOptions = data.AddOnTypes;
      this.LocationTypeOptions = data.LocationTypes;
      this.FacilityTypeOptions = data.FacilityTypes;
      this.GenderOptions = data.GenderTypes;
      // console.log(this.GenderOptions);
      this.SchoolYearOptions = data.SchoolYears.sort((a, b) => b - a).slice(
        0,
        6
      );
      this.DefaultSchoolYear = data.DefaultSchoolYear;
      this.SelectedSchoolYearOption = data.DefaultSchoolYear;
      document.getElementById("pageProgress").classList.add("hidden");
      this.DisableOptions = false;
    },

    resetSearch() {
      //console.log("Clearing search");
      this.selectedStateOption = "0";
      this.AddOnOption = [];
      this.selectedCountyOption = "0";
      this.selectedDisability1Option = "0";
      this.selectedDisability2Option = "0";
      this.SelectedSchoolYearOption = this.DefaultSchoolYear;
      this.SearchResults = [];
      this.ProgramName = "";
      this.ProgramCode = "";
      this.Age = "";
      this.Address = "";
      this.City = "";
      this.Miles = "";
      this.Zip = "";
      this.FacilityOptionSelected = "AvailableFacilities";
      this.LocationType = [];
      this.FacilityType = [];
      this.GenderType = [];
      this.ShowResults = false;
      this.SearchedButNoResults = false;
      this.IsSearchWithinRadius = false;
    },
    ClearSchoolYearSearch() {
      this.SelectedSchoolYearOption = this.DefaultSchoolYear;
      this.DoSearch();
    },
    ClearProgramCodeSearch() {
      this.ProgramCode = "";
      this.DoSearch();
    },
    ClearProgramNameSearch() {
      this.ProgramName = "";
      this.DoSearch();
    },
    ClearAddressSearch() {
      this.Address = "";
      this.DoSearch();
    },
    ClearCountySearch() {
      this.selectedCountyOption = "0";
      this.DoSearch();
    },
    ClearMilesSearch() {
      this.IsSearchWithinRadius = false;
      this.Miles = 0;
      this.IsSearchWithMiles = false;
      this.Zip = "";
      this.DoSearch();
    },
    ClearStateSearch() {
      this.selectedStateOption = "0";
      this.DoSearch();
    },
    ClearDisability1Search() {
      this.selectedDisability1Option = "0";
      this.selectedDisability2Option = "0";
      this.DoSearch();
    },
    ClearDisability2Search() {
      this.selectedDisability2Option = "0";
      this.DoSearch();
    },

    ClearAddOnSearch() {
      this.AddOnOption = [];
      this.DoSearch();
    },

    ClearCitySearch() {
      this.City = "";
      this.DoSearch();
    },
    ClearGenderSearch() {
      this.GenderType = [];
      this.DoSearch();
    },
    ClearFacilitySearch() {
      this.FacilityType = [];
      this.DoSearch();
    },
    ClearLocationSearch() {
      this.LocationType = [];
      this.DoSearch();
    },
    ClearFacilityScopeSearch() {
      this.FacilityOptionSelected = "AvailableFacilities";
      this.DoSearch();
    },
    ClearNameStartsWithSearch() {
      this.NameStartsWithOption = false;
      this.DoSearch();
    },
    DoSearch() {
      document.getElementById("pageProgress").classList.remove("hidden");
      this.SearchResults = [];
      this.SetSearchTexts();

      console.log(this.LocationType);

      //console.log(typeof(this.GenderType));

      let GenderId = this.GenderType;
      let FacilityTypeId = this.FacilityType;
      let LocationTypeId = this.LocationType;
      let AddonTypeId = this.AddOnOption;
      let CountyId =
        this.selectedCountyOption == 0 ? "" : this.selectedCountyOption.id;
      let StateTypeId =
        this.selectedStateOption == 0 ? "" : this.selectedStateOption.id;
      let Disability1Id =
        this.selectedDisability1Option == 0
          ? ""
          : this.selectedDisability1Option.id;

      let Disability2Id =
        this.selectedDisability2Option == 0
          ? ""
          : this.selectedDisability2Option.id;

      // let IsShowAvailable =
      //   this.FacilityOptionSelected == "AvailableFacilities";

      let FacilitiesScope = 0;
      switch (this.FacilityOptionSelected) {
        case "AvailableFacilities":
          FacilitiesScope = 1;
          break;
        case "AllFacilities":
          FacilitiesScope = 2;
          break;
        default:
          FacilitiesScope = 3;
      }

      //console.log(`${this.NameStartsWithOption}`);

      //      const WebURL = "https://appsqa.isbe.net/WIP_SEPF_WebApi/api/PFSearchAPI";
      const WebURL = `${Constants.API_URL}/api/PFSearchAPI`;

      const SearchMethod = "PFSearchResultsAsync";

      let SearchParameters = `programName=${this.ProgramName}&programCode=${this.ProgramCode}&selectedSchoolYear=${this.SelectedSchoolYearOption}&selectedLocationTypeId=${LocationTypeId}&selectedGenderTypeIds=${GenderId}&selectedFacilityTypeIds=${FacilityTypeId}&selectedAddOnTypeId=${AddonTypeId}&selectedCountyTypeId=${CountyId}&selectedStateTypeId=${StateTypeId}&address=${this.Address}&city=${this.City}&disability1=${Disability1Id}&disability2=${Disability2Id}&FacilitiesScope=${FacilitiesScope}&isStartsWith=${this.NameStartsWithOption}&age=${this.Age}&zip=${this.Zip}&zipMileage=${this.Miles}`;

      let SearchString = `${WebURL}/${SearchMethod}?${SearchParameters}`;

      console.log(SearchString);

      fetch(SearchString)
        .then((response) => response.json())
        .then((data) => {
        console.log(data);
          this.SearchResults = data.sort((a, b) =>
            a.ProgramName.toLowerCase() > b.ProgramName.toLowerCase() ? 1 : -1
          );
          this.ShowResults = data.length > 0 ? true : false;
          this.ResultsCount = data.length;
          this.SearchedButNoResults = data.length > 0 ? false : true;
          document.getElementById("pageProgress").classList.add("hidden");
        });
    },

    GetExcel() {
      let GenderId = this.GenderType == 0 ? "" : this.GenderType;
      let FacilityTypeId = this.FacilityType == 0 ? "" : this.FacilityType;
      let LocationTypeId = this.LocationType == 0 ? "" : this.LocationType;
      let AddonTypeId = this.AddOnOption == 0 ? "" : this.AddOnOption.id;
      let CountyId =
        this.selectedCountyOption == 0 ? "" : this.selectedCountyOption.id;
      let StateTypeId =
        this.selectedStateOption == 0 ? "" : this.selectedStateOption.id;
      let Disability1Id =
        this.selectedDisability1Option == 0
          ? ""
          : this.selectedDisability1Option.id;

      let Disability2Id =
        this.selectedDisability2Option == 0
          ? ""
          : this.selectedDisability2Option.id;

      // let IsShowAvailable =
      //   this.FacilityOptionSelected == "AvailableFacilities";

      let FacilitiesScope = 0;
      switch (this.FacilityOptionSelected) {
        case "AvailableFacilities":
          FacilitiesScope = 1;
          break;
        case "AllFacilities":
          FacilitiesScope = 2;
          break;
        default:
          FacilitiesScope = 3;
      }

      //console.log(`${this.NameStartsWithOption}`);

      const WebURL = `${Constants.API_URL}/api/PFSearchAPI`;
      const ExportMethod = "ExportSearchResults";

      let ExportParameters = `programName=${this.ProgramName}&programCode=${this.ProgramCode}&selectedSchoolYear=${this.SelectedSchoolYearOption}&selectedLocationTypeId=${LocationTypeId}&selectedGenderTypeIds=${GenderId}&selectedFacilityTypeIds=${FacilityTypeId}&selectedAddOnTypeId=${AddonTypeId}&selectedCountyTypeId=${CountyId}&selectedStateTypeId=${StateTypeId}&address=${this.Address}&city=${this.City}&disability1=${Disability1Id}&disability2=${Disability2Id}&FacilitiesScope=${FacilitiesScope}&isStartsWith=${this.NameStartsWithOption}&age=${this.Age}&zip=${this.Zip}&zipMileage=${this.Miles}`;

      let ExcelExportLinkString = `${WebURL}/${ExportMethod}?${ExportParameters}`;

      //console.log(ExcelExportLinkString);

      window.open(ExcelExportLinkString, "_blank");
    },

    ToggleSort() {
      this.IsASCSort = !this.IsASCSort;
      this.UpdateSortedList();
    },
    UpdateSortedList() {
      if (this.IsASCSort) {
        this.SearchResults = this.SearchResults.sort((a, b) =>
          a.ProgramName.toLowerCase() > b.ProgramName.toLowerCase() ? 1 : -1
        );
      } else {
        this.SearchResults = this.SearchResults.sort((a, b) =>
          a.ProgramName.toLowerCase() > b.ProgramName.toLowerCase() ? -1 : 1
        );
      }
    },
    SetSearchTexts() {
      this.ProgramCodeSearch = this.ProgramCode;
      this.SchoolYearSearch =
        this.SelectedSchoolYearOption - 1 + "-" + this.SelectedSchoolYearOption;
      this.ProgramNameSearch = this.ProgramName;
      this.IsSearchWithMiles = this.IsSearchWithinRadius;
      this.AddressSearch = this.Address;
      this.CitySearch = this.City;
      this.CountySearch =
        this.selectedCountyOption == "0" ? "" : this.selectedCountyOption.text;
      this.StateSearch =
        this.selectedStateOption == "0" ? "" : this.selectedStateOption.text;
      this.Disability1Search =
        this.selectedDisability1Option == "0"
          ? ""
          : this.selectedDisability1Option.text;
      this.Disability2Search =
        this.selectedDisability2Option == "0"
          ? ""
          : this.selectedDisability2Option.text;

      // console.log(this.AddOnOption);
      // console.log(this.AddOnOptions);

      const addonItem = this.AddOnOptions.find(
        ({ AddOnTypeId }) => AddOnTypeId == this.AddOnOption
      );

      this.AddOnSearch =
        addonItem == null ? "" : addonItem["AddOnTypeDescription"];

      // const facilityItem = this.FacilityTypeOptions.find(
      //   ({ FacilityTypeId }) => FacilityTypeId == this.FacilityType
      // );

      // this.FacilityTypeSearch =
      //   facilityItem == null ? "" : facilityItem["Description"];

      let genderItem;
      let gOptions = this.GenderOptions;
      let gSelections = [];

      this.GenderType.forEach(function (item) {
        genderItem = gOptions.find(({ GenderTypeId }) => GenderTypeId == item);
        gSelections.push(genderItem["Description"]);
      });

      this.GenderTypeSearch = gSelections.join();

      //FacilityTypeSearch

      let facItem;
      let facOptions = this.FacilityTypeOptions;
      let facSelections = [];

      this.FacilityType.forEach(function (item) {
        facItem = facOptions.find(
          ({ FacilityTypeId }) => FacilityTypeId == item
        );
        facSelections.push(facItem["Description"]);
      });

      this.FacilityTypeSearch = facSelections.join();

      // const facilityItem = this.FacilityTypeOptions.find(
      //   ({ FacilityTypeId }) => FacilityTypeId == this.FacilityType
      // );

      // this.FacilityTypeSearch =
      //   facilityItem == null ? "" : facilityItem["Description"];

      switch (this.FacilityOptionSelected) {
        case "AvailableFacilities":
          this.FacilityScopeSearch = "Available Facilities";
          break;
        case "AllFacilities":
          this.FacilityScopeSearch = "All Facilities";
          break;
        default:
          this.FacilityScopeSearch = "Recently Approved Facilities";
      }

      const locationItem = this.LocationTypeOptions.find(
        ({ LocationTypeId }) => LocationTypeId == this.LocationType
      );

      this.LocationTypeSearch =
        locationItem == null ? "" : locationItem["Description"];
    },
    DoShowName() {
      this.showName = !this.showName;
    },
    sort: function (s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
    ToggleHelp() {
      this.ShowHelpText = !this.ShowHelpText;
    },
    OpenListView() {
      this.ListView = true;
      this.MapView = false;
    },
    OpenMapView() {
      this.MapView = true;
      this.ListView = false;
    },
  },
  mounted() {
    this.loadDropdowns();
  },
  computed: {
    OrderedSchoolYears: function () {
      return this.SchoolYearOptions; //_.orderBy(this.SchoolYearOptions, "SchoolYear");
    },
    IsShowBanner: function () {
      var curMonth = new Date().getMonth();
      //console.log(curMonth);
      return curMonth >= 6 && curMonth < 8;
    },
  },
};
</script>

<style>
legend {
  font-size: 0.9rem !important;
  font-style: italic !important;
}
.pf-table-icon {
  width: 28px !important;
  max-width: 28px !important;
  vertical-align: top !important;
  padding: 0px 0px 0px 0px !important;
  /* margin: 0px !important; */
}

button.link {
  display: inline-block;
  position: relative;
  background-color: transparent;
  cursor: pointer;
  border: 0;
  padding: 0;
  color: #0080ff;
  text-decoration: none;
  font-weight: normal; /* IE insists on bold */
  font: inherit;
  padding: 0px 6px 0px 6px;
}

.pf-ghost-div {
  border-radius: 8px !important;
  border: 4px solid #e2eaee;
  background-color: ghostwhite;
}
.CurvedBorder {
  border-radius: 10px !important;
}
.borderless td,
.borderless th {
  border: none;
}
.SearchResultRow:hover {
  background-color: whitesmoke;
}
.pointer {
  cursor: pointer;
}
a.link:hover {
  color: #00cd00 !important;
  text-decoration: none;
}

.navbar {
  pointer-events: none;
  cursor: default;
}
</style>